import { getTemplateUrlWithBiParam } from '../utils/getTemplateUrlWithBiParam';
import { createHub } from '@wix/fe-essentials/error-monitor';
import { SENTRY_DSN } from '../constants/sentryDSN';
import * as Sentry from '@sentry/browser';
import { useHttpClient } from '@wix/fe-essentials/react';
import { createBlocksAppFromTemplate } from '@wix/ambassador-devcenter-apps-v1-app-template/http';
import { useTemplatesData } from './useTemplatesData';
import { useLoginNavigation } from './useLoginNavigation';
import { useEffect, useState } from 'react';
import { QueryParams } from '../constants/QueryParams';
import { useQueryParam } from './useQueryParam';
import { REFERRAL_INFO } from '../constants/routes';
import { wait } from '../utils/general';

export const useOpenBlocksEditorUrl = () => {
  const { isUserLoggedIn } = useTemplatesData();
  const httpClient = useHttpClient();
  const { getParam } = useQueryParam();
  const templateId = getParam(QueryParams.TEMPLATE_ID);
  const templateName = getParam(QueryParams.TEMPLATE_NAME);
  const isReturnedFromLoginPage = getParam(
    QueryParams.RETURNED_FROM_LOGIN_PAGE,
  );
  const [isError, setIsError] = useState(false);

  const errorMonitor = createHub({
    dsn: SENTRY_DSN,
    Sentry,
  });
  const navigateToLoginPage = useLoginNavigation(
    REFERRAL_INFO.BLOCKS_TEMPLATE_FLOW,
  );

  const openBlockUrl = async (templateId: string, templateName: string) => {
    try {
      if (!isUserLoggedIn) {
        navigateToLoginPage();
      } else {
        if (isReturnedFromLoginPage) {
          await wait(2000); // Temporary, we need to wait until blocks is added to userProfile
        }
        const { data } = await httpClient.request(
          createBlocksAppFromTemplate({
            templateId,
            templateConfig: { appInfo: { name: templateName } },
          }),
        );
        window.location.assign(getTemplateUrlWithBiParam(data.editorUrl));
      }
    } catch (e) {
      errorMonitor.captureException(e);
      setIsError(true);
    }
  };

  useEffect(() => {
    void openBlockUrl(templateId, templateName);
  }, [templateId, templateName]);

  return { isError };
};
